import convertToArray from './convertToArray';
import StopScroll from './StopScroll';

class SettingAccount {
  init() {
    this.doc = document;
    this.dialog = this.doc.getElementById('sendDialog');
    this.dialogActiveClass = 'is_active';
    this.closeBtnAttr = 'data-close-btn';
    this.closeBtn = convertToArray(this.doc.querySelectorAll(`[${this.closeBtnAttr}]`));
    this.closeBtnLen = this.closeBtn.length;
    this.backdrop = this.doc.getElementById('backdrop');
    this.backdropActiveClass = 'is_active';
    this.send = this.send.bind(this);
    this.closeDialog = this.closeDialog.bind(this);
    this.stopScroll = new StopScroll();
  }
  start() {
    this.submitBtn = document.getElementById('settingAccountSubmitBtn');
    if (!this.submitBtn) return;
    this.init();
    this.submitBtn.addEventListener('click', this.send);
  }
  send() {
    this.dialog.classList.add(this.dialogActiveClass);
    this.backdrop.classList.add(this.backdropActiveClass);
    for (let bi = 0; bi < this.closeBtnLen; bi += 1) {
      this.closeBtn[bi].addEventListener('click', this.closeDialog);
    }
    this.backdrop.addEventListener('click', this.closeDialog);
    this.stopScroll.stop();
  }
  closeDialog(e) {
    e.preventDefault();
    this.dialog.classList.remove(this.dialogActiveClass);
    this.backdrop.classList.remove(this.backdropActiveClass);
    for (let bi = 0; bi < this.closeBtnLen; bi += 1) {
      this.closeBtn[bi].removeEventListener('click', this.closeDialog);
    }
    this.backdrop.removeEventListener('click', this.closeDialog);
    this.stopScroll.reStart();
  }
}
export default SettingAccount;



// WEBPACK FOOTER //
// ./src/js/module/SettingAccount.js